const config = {
    apiUrl: 'https://authapi.digitallive24.com',
    payUrl: 'https://pay.digitallive24.com',
    logo:'https://digisign24.s3.ap-south-1.amazonaws.com/users-media/web-assets/logo.png',
    Google_Client_Id:"20661248742-cjc0h0oe53jv5tda1nbva58f6fp1tib5.apps.googleusercontent.com"
};
export default config;